import {
    Component,
    OnInit,
    ChangeDetectorRef
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { first } from 'rxjs/operators';
import { UnconfirmedUserInterface } from 'src/app/model/user/unconfirmed-user-page-interface';
import { NutzerverwaltungService } from 'src/app/services/nutzerverwaltung/nutzerverwaltung.service';

@Component({
    selector: 'app-unconfirmed-user-management',
    templateUrl: './unconfirmed-user-management.component.html',
    styleUrls: ['./unconfirmed-user-management.component.css'],
    standalone: false
})
export class UnconfirmedUserManagementComponent implements OnInit {
    totalNumberOfElements = 0;
    pageIndex = 0;
    pageSize = 10;
    private searchTerm = '';
    unconfirmedUserSlice: UnconfirmedUserInterface[] = [];

    constructor(
        private userManagementService: NutzerverwaltungService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.fetchCurrentPage();
    }

    onPageChange(pageChangeEvent: PageEvent) {
        this.pageIndex = pageChangeEvent.pageIndex;
        this.pageSize = pageChangeEvent.pageSize;
        this.fetchCurrentPage();
    }

    private fetchCurrentPage(): void {
        this.userManagementService
            .getUnconfirmedUserSlice(
                this.pageIndex,
                this.pageSize,
                this.searchTerm
            )
            .pipe(first())
            .subscribe((unconfirmedUserPage) => {
                this.totalNumberOfElements =
                    unconfirmedUserPage.totalNumberOfElements;
                this.unconfirmedUserSlice =
                    unconfirmedUserPage.unconfirmedUsers;
                this.changeDetectorRef.detectChanges();
            });
    }

    onConfirmUser(userId: number): void {
        this.userManagementService
            .openConfirmMemberDialog()
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.userManagementService
                        .confirmUserRegistration(userId)
                        .subscribe(() => this.fetchCurrentPage());
                }
            });
    }

    onDeleteUser(userId: number): void {
        this.userManagementService
            .openConfirmDeleteMemberDialog()
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.userManagementService
                        .deleteUser(userId)
                        .subscribe(() => this.fetchCurrentPage());
                }
            });
    }

    onSearchChange(searchString: string): void {
        this.searchTerm = searchString;
        this.pageIndex = 0;
        this.fetchCurrentPage();
    }
}
